export const bytesToMb = (bytes: string | number): string => {
  return (Number(bytes) / 1048576).toLocaleString();
};

export const getPercentage = (loaded: number, total: number): number => {
  return Math.round((loaded * 100) / total);
};

export const isPreviewableFileName = (fileName: string) => {
  const previewExtensions = [".gif", ".jpg", ".jpeg", ".pdf", ".png", ".bmp", ".txt"];
  const lower = fileName.toLowerCase();
  return previewExtensions.some((ext) => lower.endsWith(ext));
};
